import { StaticImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../../hooks/use_translation';

const BadgeSatisfiedCustomerGuarantee = ({
	alt,
	variant = 'normal',
	...props
}) => {
	const { language } = useTranslation();

	const variants = {
		clean: '',
		normal:
			'bg-gray-100 p-6 rounded-4 d-flex align-items-center justify-content-center',
	};

	return (
		<>
			<div className={variants[variant]} {...props}>
				{language === 'sv' ? (
					<StaticImage
						alt={alt}
						className="img-fluid mb-0 mb-lg-0"
						src="../../../images/badges/satisfied_customer_guarantee__se.png"
						style={{ maxHeight: '250px', maxWidth: '250px' }}
					/>
				) : (
					<StaticImage
						alt={alt}
						className="img-fluid mb-0 mb-lg-0"
						src="../../../images/badges/satisfied_customer_guarantee__en.png"
						style={{ maxHeight: '250px', maxWidth: '250px' }}
					/>
				)}
			</div>
		</>
	);
};

BadgeSatisfiedCustomerGuarantee.propTypes = {
	alt: PropTypes.string,
	variant: PropTypes.string,
};

export default BadgeSatisfiedCustomerGuarantee;
